import type React from "react";

export function Card({
  title,
  subtitle,
  tone = "default",
  children,
}: {
  title: string;
  subtitle?: string;
  tone?: "default" | "danger" | "ai";
  children: React.ReactNode;
}) {
  const border =
    tone === "danger"
      ? "border-red-200 dark:border-red-900/60"
      : tone === "ai"
        ? "border-zinc-200 dark:border-border border-l-4 border-l-violet-400 dark:border-l-violet-500"
        : "border-zinc-200 dark:border-border";
  return (
    <section
      className={`rounded-2xl border ${border} bg-white dark:bg-surface p-5 shadow-sm`}
      aria-labelledby={`${title.replace(/\s+/g, "-").toLowerCase()}-heading`}
    >
      <header className="mb-4 flex items-start justify-between gap-4">
        <div>
          <h2
            id={`${title.replace(/\s+/g, "-").toLowerCase()}-heading`}
            className="font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-zinc-700 dark:text-zinc-300"
          >
            {title}
          </h2>
          {subtitle ? (
            <p className="mt-1 text-[12px] text-zinc-500 dark:text-zinc-400">{subtitle}</p>
          ) : null}
        </div>
      </header>
      {children}
    </section>
  );
}
